export const getCursorFromUrl = (url?: string | null): string | null => {
    if (!url) {
        return null;
    }

    try {
        const parsed = new URL(url);
        return parsed.searchParams.get('cursor');
    } catch (err) {
        console.error(err);
        return null;
    }
};

export const readCategoryFromUrl = (): number | null => {
    if (typeof window === 'undefined') {
        return null;
    }

    const params = new URLSearchParams(window.location.search);
    const categoryParam = params.get('category');
    if (!categoryParam) {
        return null;
    }

    const parsed = parseInt(categoryParam, 10);
    return Number.isNaN(parsed) ? null : parsed;
};
